
import './User.css';
import { HeaderActivityIndicator } from '../activityIndicator/ActivityIndicator';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import ReactGA from "react-ga4";
import { Auth } from 'aws-amplify';
import { setDataRefreshRequestedDate } from './../../../redux/ducks/user';

import imageMagmicCoin from './../../../images/magmic_coin.png';
import { ModalContainer } from '../modalContainer/ModalContainer';
import { AmplifyProvider, Authenticator, Heading, useTheme } from '@aws-amplify/ui-react';
export const amplifyTheme = {
  name: 'magmic-core',
  tokens: {
    colors: {
      teal: {
        10: { value: "rgba(210, 94, 41, 0.1)" },
        20: { value: "rgba(210, 94, 41, 0.2)" },
        40: { value: "rgba(210, 94, 41, 0.4)" },
        80: { value: "rgba(210, 94, 41, 1.0)" },
        90: { value: "rgba(210, 94, 41, 0.9)" },
        100: { value: "rgba(210, 94, 41, 1)" },
      },
    },
  }
}

const SignInHeader = () => {
  const { tokens } = useTheme();

  return (
    <Heading level={6} padding={`${tokens.space.xl} ${tokens.space.xl} 0`}>
      Please sign in to make purchases.
    </Heading>
  );
}

const amplifyComponents = {
  SignIn: {
    Header: SignInHeader
  }
};

export const IdlePetParadiseForm = (props) => {

  const [bcUserId, setBcUserId] = useState("");
  const [bcUserIdIsValid, setBcUserIdIsValid] = useState(false);
  const [bcUserIdError, setBcUserIdError] = useState("");
  const [bcPassword, setBcPassword] = useState("");
  const [bcPasswordIsValid, setBcPasswordIsValid] = useState(false);
  const [bcPasswordError, setBcPasswordError] = useState("");
  const [updateCognitoAttributesPending, setUpdateCognitoAttributesPending] = useState(false);
  const [updateCognitoAttributesComplete, setUpdateCognitoAttributesComplete] = useState(false);
  const [updateCognitoAttributesErrorMessage, setUpdateCognitoAttributesErrorMessage] = useState("");

  const dispatch = useDispatch();

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  
  useEffect(
    () => {

      const user = userReduxStore.user;

      if (!user) {
        console.error("IdlePetParadiseForm user not found in redux store");
        return;
      }
    
      const bcConnectedUserId = user.attributes && user.attributes.hasOwnProperty("custom:bc_user_id") ? user.attributes["custom:bc_user_id"] : undefined;
      let bcUserIdPrefilledValue = null;
      if (bcConnectedUserId) {
        bcUserIdPrefilledValue = bcConnectedUserId;
      } else {
        const userName = user.attributes ? user.attributes.email : undefined;
        if (userName) {
          bcUserIdPrefilledValue = userName;
        }
      }
      if (bcUserIdPrefilledValue) {
        setBcUserIdIsValid(true)
        setBcUserId(bcUserIdPrefilledValue);
      }
    },
    []
  );

  const updateUser = async () => {
    setUpdateCognitoAttributesPending(true);
    try {
      let user = await Auth.currentAuthenticatedUser(); // get the authenticated user from AWS Auth

      await Auth.updateUserAttributes(user, {
        'custom:bc_user_id': bcUserId,
        'custom:bc_password': bcPassword
      });

      user = await Auth.currentAuthenticatedUser(); // get the authenticated user from AWS Auth

      let bcConnectedUserId = user.attributes && user.attributes.hasOwnProperty("custom:bc_user_id") ? user.attributes["custom:bc_user_id"] : undefined;
      let bcConnectedUserPassword = user.attributes && user.attributes.hasOwnProperty("custom:bc_password") ? user.attributes["custom:bc_password"] : undefined;

      // confirm attribute update was successful and then confirm creds with a login attempt
      if ((bcConnectedUserId === bcUserId) &&
          (bcConnectedUserPassword === bcPassword)) {

        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            userId: bcConnectedUserId,
            password: bcConnectedUserPassword
          })
        };

        let apiEndpointURL = "";
        switch (process.env.REACT_APP_ENV) {
          case "staging":
            apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/user/login";
            break;
          default:
            apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/user/login";
            break;
        }

        fetch(apiEndpointURL, requestOptions)
        .then(response => response.json())
        .then(data => {
          setUpdateCognitoAttributesPending(false);
          // grabbing some semi-arbitrary data to confirm successful login
          const forteData = data.response && data.response.hasOwnProperty("forteData") ? data.response.forteData : undefined;
          const magmicCoin = data.response && data.response.hasOwnProperty("magmicCoin") ? data.response.magmicCoin : undefined;
          if (forteData && magmicCoin) {
            if (!window.location.href.startsWith("http://localhost")) {
              ReactGA.event("link_game_account", {success: true});
            }
            setUpdateCognitoAttributesComplete(true);
            dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user refresh
          } else {
            if (!window.location.href.startsWith("http://localhost")) {
              ReactGA.event("link_game_account", {success: false});
            }
            setUpdateCognitoAttributesErrorMessage("Link failed. Please try again.");
          }
        });
      } else {
        setUpdateCognitoAttributesPending(false);
        setUpdateCognitoAttributesErrorMessage("User attribute update failed. Please try again.");
      }
    } catch (error) {
      setUpdateCognitoAttributesPending(false);
      setUpdateCognitoAttributesErrorMessage(error.message);
    }
  };


  const emailPatternFilter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; // https://www.codegrepper.com/code-examples/javascript/javascript+email+validation+w3schools
  const validateBcUserId = (currentInput) => {

    if (!emailPatternFilter.test(currentInput)) {
      setBcUserIdError("Please enter a valid email address."); // clear error if present
      return false;  
    }

    setBcUserIdError(null); // clear error if present
    return true;
  }

  const validateBcPassword = (currentInput) => {

    if (currentInput.length < 5 ) {
      setBcPasswordError("Password must be at least 5 characters."); // clear error if present
      return false;  
    }

    setBcPasswordError(null); // clear error if present
    return true;
  }

  const onInputChange = (event) => {
    let currentInput = event.target.value.trim();
    switch (event.target.id) {
      case "bcUserId":
        setBcUserIdIsValid(validateBcUserId(currentInput));
        setBcUserId(currentInput);
        break;
      case "bcPassword":
        setBcPasswordIsValid(validateBcPassword(currentInput));
        setBcPassword(currentInput);
        break;
      default:
        break;
    }
  }

  const updateCognitoAttributes = (event) => {
    if (!bcUserIdIsValid || !bcPasswordIsValid) {
      return;
    }
    if (event.preventDefault) {
      event.preventDefault();
    }

    updateUser();
  };

  const keydownEventListener = event => {
    if (event.code === "Enter" || event.code === "NumpadEnter") { // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
      updateCognitoAttributes(event);
    }
  };
  useEffect(() => {
    document.removeEventListener("keydown", keydownEventListener);
    document.addEventListener("keydown", keydownEventListener);
    return () => {
      document.removeEventListener("keydown", keydownEventListener);
    };
  }, [
    bcUserIdIsValid,
    bcPasswordIsValid
  ]);

  if (updateCognitoAttributesErrorMessage) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          {updateCognitoAttributesErrorMessage}
        </p>
        <div className="actions">
          <button className="cancel" onClick={props.onDismiss}>Close</button>
        </div>
      </div>
      </>
    )
  }
  if (updateCognitoAttributesComplete) {
    return (
      <>
      <div className="marketplaceModal">
        <p>
          Linked successfully!
        </p>
        <div className="actions">
          <button className="buy" onClick={props.onSuccess}>Close</button>
        </div>
      </div>
      </>
    )
  }

  let growToFitSourceForBCUserId = "8888888888888888"; // Using '8's as spacers
  if (bcUserId && (bcUserId.length > growToFitSourceForBCUserId.length)) {
    growToFitSourceForBCUserId = "";
    while (growToFitSourceForBCUserId.length < bcUserId.length) {
      growToFitSourceForBCUserId += "8";
    }
  }

  let growToFitSourceForBCPassword = "8888888888888888"; // Using '8's as spacers
  if (bcUserId && (bcUserId.length > growToFitSourceForBCPassword.length)) {
    growToFitSourceForBCPassword = "";
    while (growToFitSourceForBCPassword.length < bcUserId.length) {
      growToFitSourceForBCPassword += "8";
    }
  }

  return (
    <>
    <HeaderActivityIndicator isLoading={updateCognitoAttributesPending} />
    <form onSubmit={updateCognitoAttributes} className="marketplaceModal transactionsForm">{/* using form+onSubmit to enable 'enter' key submissions */}
      <div>
        Enter your Idle Pet Paradise sign in creds below
      </div>
      <div className="inputs">
        <div className="growToFitWrapper">{/* wrapper div to grow as bcUserId gets larger */}
          <span className="growToFitSourceForBCUserId">{growToFitSourceForBCUserId}</span>
          {/* input is positioned absolute to parent div in order to enable grow-to-fit*/}
          <input id="bcUserId" className="growToFitInput" type="text" placeholder="Email address" value={bcUserId} onChange={onInputChange} /* Disable autocomplete: */ autoComplete="new-password" name="bcUserId" />
        </div>
        {bcUserIdError ?
          <div className="errorMessage">{bcUserIdError}</div>
        :
          null
        }
      </div>
      <div className="inputs">
        <div className="growToFitWrapper">{/* wrapper div to grow as bcUserId gets larger */}
          <span className="growToFitSourceForBCUserId">{growToFitSourceForBCPassword}</span>
          {/* input is positioned absolute to parent div in order to enable grow-to-fit*/}
          <input id="bcPassword" className="growToFitInput" type="password" placeholder="Password" value={bcPassword} onChange={onInputChange} /* Disable autocomplete: */ autoComplete="new-password" name="bcPassword" />
        </div>
        {bcPasswordError ?
          <div className="errorMessage">{bcPasswordError}</div>
        :
          null
        }
      </div>
      <div className="actions">
        <button disabled={updateCognitoAttributesPending} className="cancel" onClick={(event) => {
          event.preventDefault();
          props.onDismiss();
        }}>
          Cancel
        </button>
        <button disabled={updateCognitoAttributesPending || !bcUserIdIsValid || !bcPasswordIsValid} type="submit" className="buy">{bcUserIdIsValid ? 
          "Link"
        :
          "Link"
        }</button>
      </div>
    </form>
    </>
  )
};

export const SignInModal = (props) => {
  return (
    <ModalContainer
      title={props.title ? props.title : "Magmic Core Sign In"}
      smallPromptFormat={true}
      noMainContentPadding={true}
      hideHeaderDismissButton={false}
      onDismiss={props.onDismiss}
    >
      <div className="AmplifyWrapper">
        <AmplifyProvider theme={amplifyTheme}>
          <Authenticator loginMechanisms={['email']} components={amplifyComponents}></Authenticator>
        </AmplifyProvider>
      </div>
    </ModalContainer>
  );
};

export const InsufficientMagmicCoinsModal = (props) => {

  const [loading, setLocalLoading] = useState(true);
  const [forteLinkUrl, setForteLinkUrl] = useState(undefined);
  const [userClickedForteLink, setUserClickedForteLink] = useState(false);

  const userReduxStore = useSelector(state => {
    return state.user;
  });

  const dispatch = useDispatch();

  useEffect(
    () => {
      setLocalLoading(!userReduxStore.loadComplete); // user has loaded, assets ready
    },
    [userReduxStore.loadComplete] // run on redux user state updates
  );

  const onDismiss = () => {
    if (userClickedForteLink) {
      dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user data refresh
    }
    props.onDismiss();
  };

  const bcConnectedUserId = userReduxStore.user && userReduxStore.user.bcConnectedUserId ? userReduxStore.user.bcConnectedUserId : undefined;
  const bcConnectedUserPassword = userReduxStore.user && userReduxStore.user.bcConnectedUserPassword ? userReduxStore.user.bcConnectedUserPassword : undefined;

  if (!bcConnectedUserId || !bcConnectedUserPassword) {
    
    dispatch(setDataRefreshRequestedDate(new Date())); // trigger an App.useEffect user data refresh

  } else if (!forteLinkUrl) {

    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        userId: bcConnectedUserId,
        password: bcConnectedUserPassword
      })
    };
  
    let apiEndpointURL = "";
    switch (process.env.REACT_APP_ENV) {
      case "staging":
        apiEndpointURL = "https://cf35m63tng.execute-api.us-east-1.amazonaws.com/test/user/forte/getlinkurl";
        break;
      default:
        apiEndpointURL = "https://q645yqsbml.execute-api.us-east-1.amazonaws.com/prod/user/forte/getlinkurl";
        break;
    }

    // get the forte link url
    fetch(apiEndpointURL, requestOptions)
    .then(linkRequestResponse => linkRequestResponse.json())
    .then(forteLinkData => {
      if (!forteLinkData.response) {
        return;
      }

      if (forteLinkData.response.linkUrl) {
        setForteLinkUrl(forteLinkData.response.linkUrl);
      }
    });
  }

  return (
    <ModalContainer
      title={props.title}
      smallPromptFormat={true}
      onDismiss={onDismiss}
    >
      {!forteLinkUrl ? 
        <div className="marketplaceModal">
          <HeaderActivityIndicator isLoading={true} />
          <p>
            Getting your Forte Exchange link ...
          </p>
        </div>      
      :
        <div className="marketplaceModal">
          {!userClickedForteLink ? 
            <>
              <p>
                You do not have enough Magmic Coin to purchase {props.assetName}.
              </p>
              <p>
                You have <img className="currency" src={imageMagmicCoin} />{userReduxStore.magmicCoin / 1000000000} available.
              </p>
              <p>
                Click below to go to Forte Exchange.
              </p>
              <div className="actions">
                <a href={forteLinkUrl} target="_blank" onClick={() => {setUserClickedForteLink(true)}}>Buy Magmic Coin</a>
              </div>
            </>
          :
            <>
              <p>
                Now that you have visited Forte Exchange, click below and retry purchasing {props.assetName}.
              </p>
              <div className="actions">
                <button className="buy" onClick={onDismiss}>Close</button>
              </div>
            </>
          }
        </div>
      }
    </ModalContainer>
  );
};